<template>
    <div  v-if="no_assertion_found === 'true'">
        <h2 class="heading" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}">
            <br/>
            <span  v-bind:style="{ color: getCorpHeadingColor}">To access TONE, navigate to the Learning Homepage in Workday<br/>and click on the TONE Networks link.</span>
            <br/><br/>
        </h2>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'sso',
        data: function () {
            return {
                user: {
                    userId: 0,
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                    packageId: 0,
                    comments: '',
                    phoneNumber: '',
                    picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/Sneakers.png',
                    userRegion: 0
                },
                emailPattern: "^[a-zA-Z0-9._%+'\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}(\\.[a-zA-Z]{2,})?$",
                showMobileFlag: true,
                phoneNumber: '',
                rawPhoneNumber: '',
                spinner: false,
                alert: false,
                passwordError: '',
                paymentSection: false,
                isToggle: false,
                isChecked: false,
                defaultPlan: '',
                showResetModal: false,
                // sso1data: this.$route.params.sso1data,
                corporation_id: this.$route.query.corporation_id,
                redirect_uri: this.$route.query.redirect_uri,
                no_assertion_found: this.$route.query.no_assertion_found,
                errorMessage: ''
            }
        },
        mounted () {
            var self = this
            console.log('HorizonssTemp ========> corporation_id = ', this.corporation_id) // Output: "2" (as a string)
            console.log('HorizonssTemp ========> redirect_uri = ', this.redirect_uri)  // Output: "name"
            console.log('HorizonssTemp ========> no_assertion_found = ', this.no_assertion_found)  // Output: "name"
            //
            console.log('HorizonssTemp ========> window.location.href = ', window.location.href)
            if (localStorage.getItem('event_corporation_id')) {
                localStorage.removeItem('event_corporation_id')
            }
            if (localStorage.getItem('event_redirect_uri')) {
                localStorage.removeItem('event_redirect_uri')
            }
            var origin = this.returnDonwloadUrl()
            console.log('origin = ', origin)
            if (!this.no_assertion_found || this.no_assertion_found === 'false') {
                if (this.redirect_uri && this.redirect_uri.indexOf('/event/') > -1) {
                    localStorage.setItem('event_corporation_id', 200)
                    localStorage.setItem('event_redirect_uri', this.redirect_uri)
                }
                console.log('2 ====================> Starting Prococessing SAML Attributes ::: ')
                window.location.href = origin                           // 'https://api1.dev-tonenetworks.com/v1/login/sendSamlRequest'
                // }
            } else {
                if (self.isUserLoggedIn && self.isUserLoggedIn.userId > 0) {
                    console.log('user is logged in. LOGGING OUT : self.isUserLoggedIn = ', self.isUserLoggedIn)
                    self.$store.dispatch('LOGOUTHORIZON', self.isUserLoggedIn)
                }
            }
        },
        methods: {
            loginWithSAML () {
                // window.location.href = 'https://api1.dev-tonenetworks.com/v1/login/sendSamlRequest'
            },
            returnDonwloadUrl () {
                let href = window.location.href
                let origin = 'https://api1.tonenetworks.com/v1/login/sendSamlRequestTest'
                console.log('horizonssotemp : href = ', href)
                if (href.indexOf('localhost') > -1 || href.indexOf('dev') > -1) {
                    origin = 'https://api1.dev-tonenetworks.com/v1/login/sendSamlRequestTest'
                    // origin = 'http://localhost:8080/v1/login/sendSamlRequest'
                }
                return origin
            }
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'error', 'getAlertMsgStatus', 'getTrialDays', 'getCorporateGiftingCode', 'getCorporateClientId', 'getCorporateClient', 'getOriginalVideoCode', 'getMessageDuration', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getCorporateGiftInfo'
            ]),
            currentRoute () {
                return this.$route
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// HorizonssoTemp.vue?02fe3c59